
const mutations = {
    SET_CONID_MAP(state, map) {
        map.forEach(m => state.conids[m.conid] = m);
    },
    PTF_MODEL_CONIDS(state, { acctId, model, list }) {
        Vue.set(state.modelConids, acctId+model, list);
    },
    PTF_MODEL_NLVS(state, { acctId, model, nlv }) {
        Vue.set(state.portfolioModelsNlv, acctId+model, nlv);
    },
    PTF_MODELS(state, { acctId, list }) {
        Vue.set(state.portfolioModels, acctId, list);
    },
    SET_MISSING_ISERVERACC_STATUS(state, val) {
        state.isMissingIServerAccount = val;
    },
    SET_COMBO_POSITIONS(state, { acctId, data }) {
        Vue.set(state.comboPositions, acctId, data);
    },
    SET_PTF_POSITIONS(state, { acctId, model, data }) {
        const ptfPos = state.portfolioPositions;
        let isAlreadyStored = false;
        // update the positions if model already exists in array
        if (ptfPos[acctId]) {
            ptfPos[acctId].forEach(e => {
                if (e.model === model) {
                    e.positions = data;
                    isAlreadyStored = true;
                }
            });
        }
        if (!isAlreadyStored) {
            if (ptfPos[acctId]) {
                ptfPos[acctId].push({
                    model: model,
                    positions: data
                });
            } else {
                const arr = [{
                    model: model,
                    positions: data
                }];
                ptfPos[acctId] = arr;
            }
        }
        state.portfolioPositions = ptfPos;
    },
    SET_PNL_AUTH(state, val) {
        state.authenticated = val;
    },
    SET_PNL_POSITIONS(state, { acctId, model, data }) {
        const ptfPos = state.pnlPositions;
        const total = data.total || {};
        const combos = data.combos || {};
        const positions = data.positions || {};
        const updates = data.updates || {};
        let isAlreadyStored = false;
        // update the positions if model already exists in array
        if (ptfPos[acctId]) {
            for (let i = 0; i < ptfPos[acctId].length; i++) {
                const e = ptfPos[acctId][i];
                if (e.model === model) {
                    e.total = total;
                    if (Object.keys(positions).length > 0) {
                        //We enter this because user places some order and it is executed
                        for (const conid in positions) {
                            let existingPos = false;
                            for (let j = 0; j < e.positions.length; j++) {
                                if (e.positions[j]['conid'] == conid) {
                                    const updatedPos = { ...e.positions[j], ...positions[conid] };
                                    Vue.set(e.positions, j, updatedPos);
                                    existingPos = true;
                                    break;
                                }
                            }
                            if (!existingPos) {
                                //if not found in current positions, means a new contract position
                                e.positions.push(positions[conid]);
                            }
                        }
                    }
                    //loop through updates and update positions
                    for (const conid in updates) {
                        for (let k = 0; k < e.positions.length; k++) {
                            if (e.positions[k]['conid'] == conid) {
                                const updatedPos = { ...e.positions[k], ...updates[conid] };
                                Vue.set(e.positions, k, updatedPos);
                                break;
                            }
                        }
                    }
                    //Will review this again later
                    if (Object.keys(combos).length > 0) {
                        e.combos = { ...e.combos, ...combos };
                    }
                    isAlreadyStored = true;
                    break;
                }
            }
            //This is needed to make data reactive
            state.pnlPositions = { ...ptfPos };
        }
        if (!isAlreadyStored) {
            const temp = [];
            for (const conid in positions) {
                temp.push(positions[conid]);
            }
            if (ptfPos[acctId]) {
                ptfPos[acctId].push({
                    model: model,
                    combos: combos,
                    positions: temp,
                    total: total
                });
            } else {
                const arr = [{
                    model: model,
                    combos: combos,
                    positions: temp,
                    total: total
                }];
                ptfPos[acctId] = arr;
            }
        }
    },
    SET_ACCOUNT_SUMMARY(state, { acctId, data }) {
        const store = {
            acctId: acctId,
            data: data
        };
        for (let x = 0; x < state.accountSummary.length; x++) {
            let summary = state.accountSummary[x];
            if (summary.acctId == acctId) {
                Vue.set(state.accountSummary, x, store);
                return;
            }
        }
        state.accountSummary.push(store);
    },
    SET_ACCOUNT_LEDGER(state, { acctId, data }) {
        const store = {
                acctId: acctId,
                data: data
        };
        for (let x = 0; x < state.accountLedger.length; x++) {
            let ledger = state.accountLedger[x];
            if (ledger.acctId == acctId) {
                Vue.set(state.accountLedger, x, store);
                return;
            }
        }
        state.accountLedger.push(store);
    },
    SET_PORTFOLIO_ALLOCATION(state, data) {
        state.allocation = data;
    },
    SET_IBKRAM_INFO(state, models) {
        state.ibkramModels = models;
    },
    SET_ACCOUNT_META(state, val) {
        state.accountMeta = val;
    },
    SET_MODELS_LEDGER(state, { acctId, modelName, modelDescription, data }) {
        data.description = modelDescription;
        data.name = modelName;
        Vue.set(state.ledgerModels, acctId, {...state.ledgerModels[acctId], ...{ [modelName]: data } });
    },
    PTF_POSITIONS_SIMPLE(state, { acctId, list }) {
        Vue.set(state.portfolioPositionsSimple, acctId, list);
    },
    SET_PORTFOLIO_ACCOUNTS(state, data) {
        state.portfolioAccounts = data;
    }
}

export default mutations;
